const {
    REACT_APP_MEETS_BASE_URL_STAGING,
    REACT_APP_MEETS_WS_URL_STAGING,
    REACT_APP_DASHBOARD_URL_STAGING,
    REACT_APP_WEBSITE_URL_STAGING,
    REACT_APP_BLOGS_URL_STAGING,
    REACT_APP_OHR_V1_BASE_URL_STAGING,

    REACT_APP_MEETS_BASE_URL_BETA,
    REACT_APP_MEETS_WS_URL_BETA,
    REACT_APP_DASHBOARD_URL_BETA,
    REACT_APP_WEBSITE_URL_BETA,
    REACT_APP_BLOGS_URL_BETA,
    REACT_APP_OHR_V1_BASE_URL_BETA,
    REACT_APP_HOTJAR_ID_BETA,

    REACT_APP_MEETS_BASE_URL_DEMO,
    REACT_APP_MEETS_WS_URL_DEMO,
    REACT_APP_DASHBOARD_URL_DEMO,
    REACT_APP_WEBSITE_URL_DEMO,
    REACT_APP_BLOGS_URL_DEMO,
    REACT_APP_OHR_V1_BASE_URL_DEMO,

    REACT_APP_MEETS_BASE_URL_PRODUCTION,
    REACT_APP_MEETS_WS_URL_PRODUCTION,
    REACT_APP_DASHBOARD_URL_PRODUCTION,
    REACT_APP_WEBSITE_URL_PRODUCTION,
    REACT_APP_BLOGS_URL_PRODUCTION,
    REACT_APP_OHR_V1_BASE_URL_PRODUCTION,
    REACT_APP_HOTJAR_ID_PRODUCTION,
    REACT_APP_HEAP_ID_PRODUCTION,

    // default envs
    REACT_APP_MEETS_BASE_URL,
    REACT_APP_MEETS_WS_URL,
    REACT_APP_DASHBOARD_URL,
    REACT_APP_WEBSITE_URL,
    REACT_APP_BLOGS_URL,
    REACT_APP_OHR_V1_BASE_URL,
    REACT_APP_HOTJAR_ID,
    REACT_APP_HEAP_ID,
} = process.env

export const urlEnvironments = {
    DEVELOPMENT: {
        MEETS_BASE_URL:
            REACT_APP_MEETS_BASE_URL_STAGING || REACT_APP_MEETS_BASE_URL,
        MEETS_WS_URL: REACT_APP_MEETS_WS_URL_STAGING || REACT_APP_MEETS_WS_URL,
        DASHBOARD_URL:
            REACT_APP_DASHBOARD_URL_STAGING || REACT_APP_DASHBOARD_URL,
        WEBSITE_URL: REACT_APP_WEBSITE_URL_STAGING || REACT_APP_WEBSITE_URL,
        BLOGS_URL: REACT_APP_BLOGS_URL_STAGING || REACT_APP_BLOGS_URL,
        OHR_V1_BASE_URL:
            REACT_APP_OHR_V1_BASE_URL_STAGING || REACT_APP_OHR_V1_BASE_URL,
    },
    STAGING: {
        MEETS_BASE_URL:
            REACT_APP_MEETS_BASE_URL_STAGING || REACT_APP_MEETS_BASE_URL,
        MEETS_WS_URL: REACT_APP_MEETS_WS_URL_STAGING || REACT_APP_MEETS_WS_URL,
        DASHBOARD_URL:
            REACT_APP_DASHBOARD_URL_STAGING || REACT_APP_DASHBOARD_URL,
        WEBSITE_URL: REACT_APP_WEBSITE_URL_STAGING || REACT_APP_WEBSITE_URL,
        BLOGS_URL: REACT_APP_BLOGS_URL_STAGING || REACT_APP_BLOGS_URL,
        OHR_V1_BASE_URL:
            REACT_APP_OHR_V1_BASE_URL_STAGING || REACT_APP_OHR_V1_BASE_URL,
    },
    DEMO: {
        MEETS_BASE_URL:
            REACT_APP_MEETS_BASE_URL_DEMO || REACT_APP_MEETS_BASE_URL,
        MEETS_WS_URL: REACT_APP_MEETS_WS_URL_DEMO || REACT_APP_MEETS_WS_URL,
        DASHBOARD_URL: REACT_APP_DASHBOARD_URL_DEMO || REACT_APP_DASHBOARD_URL,
        WEBSITE_URL: REACT_APP_WEBSITE_URL_DEMO || REACT_APP_WEBSITE_URL,
        BLOGS_URL: REACT_APP_BLOGS_URL_DEMO || REACT_APP_BLOGS_URL,
        OHR_V1_BASE_URL:
            REACT_APP_OHR_V1_BASE_URL_DEMO || REACT_APP_OHR_V1_BASE_URL,
    },
    BETA: {
        MEETS_BASE_URL:
            REACT_APP_MEETS_BASE_URL_BETA || REACT_APP_MEETS_BASE_URL,
        MEETS_WS_URL: REACT_APP_MEETS_WS_URL_BETA || REACT_APP_MEETS_WS_URL,
        DASHBOARD_URL: REACT_APP_DASHBOARD_URL_BETA || REACT_APP_DASHBOARD_URL,
        WEBSITE_URL: REACT_APP_WEBSITE_URL_BETA || REACT_APP_WEBSITE_URL,
        BLOGS_URL: REACT_APP_BLOGS_URL_BETA || REACT_APP_BLOGS_URL,
        OHR_V1_BASE_URL:
            REACT_APP_OHR_V1_BASE_URL_BETA || REACT_APP_OHR_V1_BASE_URL,
        HOTJAR_ID: REACT_APP_HOTJAR_ID_BETA || REACT_APP_HOTJAR_ID,
    },
    PRODUCTION: {
        MEETS_BASE_URL:
            REACT_APP_MEETS_BASE_URL_PRODUCTION || REACT_APP_MEETS_BASE_URL,
        MEETS_WS_URL:
            REACT_APP_MEETS_WS_URL_PRODUCTION || REACT_APP_MEETS_WS_URL,
        DASHBOARD_URL:
            REACT_APP_DASHBOARD_URL_PRODUCTION || REACT_APP_DASHBOARD_URL,
        WEBSITE_URL: REACT_APP_WEBSITE_URL_PRODUCTION || REACT_APP_WEBSITE_URL,
        BLOGS_URL: REACT_APP_BLOGS_URL_PRODUCTION || REACT_APP_BLOGS_URL,
        OHR_V1_BASE_URL:
            REACT_APP_OHR_V1_BASE_URL_PRODUCTION || REACT_APP_OHR_V1_BASE_URL,
        HOTJAR_ID: REACT_APP_HOTJAR_ID_PRODUCTION || REACT_APP_HOTJAR_ID,
        HEAP_ID: REACT_APP_HEAP_ID_PRODUCTION || REACT_APP_HEAP_ID,
    },
}
